import React, { useContext } from 'react';
import { CartContext } from '../../contexts/CartContext';

export const Loading = () => {
    const { isLoading } = useContext(CartContext);
    if (isLoading) {
        return (
            <div className="loading__overlay">
                <div className="loading__content">
                    <img src="/Tsc/en_CA/Assets/images/svg/ring-alt.svg" alt="Loading" />
                </div>
            </div>
        );
    } else {
        return null;
    }
};
